import { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchGeneriqueDataByType } from "../../reduxStore/GeneriqueDataSlice"; // ⚡ Make sure you have this action!
import { RootState, AppDispatch } from "../../reduxStore/Store";
import { GeneriqueData } from "../../models/models";
import { GeneriqueDataType } from "../../constants/enums";

interface SelectModeReglementProps
extends Omit<SelectProps<number | string>, "value" | "onChange"> {
  onModeReglementChange: (generiqueData: GeneriqueData | null) => void;
  selectedModeReglement?: GeneriqueData | null;
  /** Affiche une option « Tous les modes » (valeur vide) — utile en filtre */
  includeAllOption?: boolean;
}


const SelectModeReglement: React.FC<SelectModeReglementProps> = ({
  onModeReglementChange,
  selectedModeReglement,
  includeAllOption = false,
  ...selectProps
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { modeReglementData, loading, error } = useSelector(
    (state: RootState) => state.GeneriqueDataSlice
  );
  const [modeReglementId, setModeReglementId] = useState<number | string>("");

  useEffect(() => {
    dispatch(fetchGeneriqueDataByType({ type:GeneriqueDataType.MODE_REGLEMENT }));
  }, [dispatch]);

  useEffect(() => {
    if (selectedModeReglement) {
      setModeReglementId(selectedModeReglement.id);
    } else {
      // Sélection annulée → revient sur « Tous »
      setModeReglementId("");
    }
  }, [selectedModeReglement]);

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const selectedId = event.target.value;
    const selectedModeReglement = modeReglementData.find((item) => item.id === Number(selectedId)) || null;
    setModeReglementId(selectedId);
    onModeReglementChange(selectedModeReglement);
  };

  return (
    <FormControl fullWidth size="small" variant="outlined" error={!!error}>
      <InputLabel id="select-mode-reglement-label">Mode de Règlement</InputLabel>
      <Select
        labelId="select-mode-reglement-label"
        value={modeReglementId}
        onChange={handleChange}
        label="Mode de Règlement"
        disabled={loading}
        size="small"
        {...selectProps}
      >
        {modeReglementData.length === 0 ? (
          <MenuItem value="">Aucun mode de règlement trouvé</MenuItem>
        ) : (
          [
            includeAllOption && (
              <MenuItem key="__all__" value="">
                <em>Tous les modes</em>
              </MenuItem>
            ),
            ...modeReglementData.map((modeItem) => (
              <MenuItem key={modeItem.id} value={modeItem.id}>
                {modeItem.nom}
              </MenuItem>
            )),
          ]
        )}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SelectModeReglement;
